<span *ngIf="text$ | async as texts">
  <span *ngFor="let text of texts" class="tag me-2 small">
    {{ text | translate }}
  </span>
</span>
